import React, { FC, useRef } from 'react'
import Joyride, { ACTIONS, CallBackProps, STATUS, Step, Styles } from 'react-joyride'
import { isMobile } from 'react-device-detect'

import { GameFlowSteps } from 'types'
import { useHistory, useRouteMatch } from 'react-router-dom'

interface IntroTutorialProps {
  run: boolean
  steps: Step[]
  onClose: () => void
  styles: Styles
  setGameState?: (state: GameFlowSteps) => void
}

export const IntroTutorial: FC<IntroTutorialProps> = ({ run, steps, onClose, styles, setGameState }) => {
  const history = useHistory()
  const { path } = useRouteMatch()
  const joyRef: any = useRef()

  const handleJoyrideCallback = (data: CallBackProps) => {
    if (data.action === ACTIONS.CLOSE || data.status === STATUS.FINISHED) {
      onClose()
      if (data.status === STATUS.FINISHED) {
        if (isMobile) {
          return history.push(`/event`)
        }
        setGameState && setGameState(GameFlowSteps.Welcome)
      }
    }
    if (data.action === ACTIONS.NEXT && data.lifecycle === 'complete') {
      if (data.index === 1) {
        if (isMobile) {
          return history.push(`${path}/dod-use-cases`)
        }
        setGameState && setGameState(GameFlowSteps.Sessions)
      } else if (data.index === 2) {
        if (isMobile) {
          return history.push(`${path}/other-use-cases`)
        }
        setGameState && setGameState(GameFlowSteps.Explore)
      }
    }
    if (isMobile && data.action === ACTIONS.PREV && data.index === 2) {
      history.goBack()
    }
    if (data.action === ACTIONS.STOP && data.index > 0) {
      // reset the state of the tutorial directly
      joyRef.current.setState(joyRef.current.initStore())
    }
  }

  return (
    <Joyride
      run={run}
      steps={steps}
      styles={
        !isMobile
          ? {
              ...styles,
              tooltip: { ...styles.tooltip, width: '450px' },
              overlay: { height: '100vh' },
              beacon: { display: 'none' }
            }
          : isMobile
          ? { ...styles, tooltip: { ...styles.tooltip, width: '90vw' } }
          : styles
      }
      callback={handleJoyrideCallback}
      continuous={true}
      floaterProps={{
        disableAnimation: true,
        styles: {
          floater: {
            filter: 'drop-shadow(rgba(0, 0, 0, 1) 0px 0px 1px)'
          }
        }
      }}
      locale={{ last: 'Finish' }}
      ref={joyRef}
    />
  )
}
